export function getMap() {
    return window.app.map
}
